module.exports = __webpack_public_path__ + "img/dashboard8.fcb3944c.png";